<template>
	<div class="competition">
		<div class="competition-l" @click="toDetail">
			<div class="competition-name">
				<h3>{{comItem.competitionName}}</h3>
				<span v-if="comItem.status==1">火热进行中</span>
			</div>
			<div class="competition-info" :class="{'line2':isLine2}" v-html="comItem.content">

			</div>
			<div class="competition-tips">
				<span class="organizer">举办方：{{comItem.organizer}}</span>
				<span v-if="!!comItem.bonus" class="bonus">奖金：{{comItem.bonus}}</span>
			</div>
		</div>
		<!-- <div class="competition-m" @click="toDetail">
			<ul>
				<li>
					<span>{{comItem.enrollTeamNum}}</span>
					<span>团队数</span>
				</li>
				<li>
					<span>{{comItem.enrollNum}}</span>
					<span>报名人数</span>
				</li>
			</ul>
			<div class="deadline">大赛截止时间：{{comItem.endTime | datefmt('yyyy-MM-DD')}}</div>
		</div> -->
		<div class="competition-r">
			<a href="javascript:;" class="submit-btn" @click.stop="toEnter" v-if="comItem.enrollFlag!=1">立即报名</a>
			<a href="javascript:;" class="submit-btn"  v-if="comItem.enrollFlag==1">已报名</a>
			<span v-if="comItem.status==1">剩余 {{day}} 天 {{hour}} 小时</span>
			<span>报名截止时间：{{comItem.endTime | datefmt('yyyy-MM-DD')}}</span>
		</div>
		<el-dialog
		title="大赛报名"
		destroy-on-close
		:visible="applicationDialog"
		:before-close="closeDialog"
		width="50%">
		  <div class="dialog-wrap">
			  <el-form :model="formInfo" :rules="rules" ref="formInfo" label-width="100px" class="demo-ruleForm">
			  	<el-form-item label="姓名" prop="userName">
			  		<el-input clearable placeholder="请输入联系人姓名" v-model="formInfo.userName"></el-input>
			  	</el-form-item>
			  	<el-form-item label="联系人电话" prop="phone">
			  		<el-input clearable placeholder="请输入您的电话" v-model="formInfo.phone"></el-input>
			  	</el-form-item>
				<el-form-item label="单位名称" prop="companyName">
					<el-input clearable placeholder="请输入单位名称" v-model="formInfo.companyName"></el-input>
				</el-form-item>
				<el-form-item label="邮箱" prop="email">
					<el-input clearable placeholder="请输入您的邮箱" v-model="formInfo.email"></el-input>
				</el-form-item>
			  </el-form>
			  <a href="javascript:;" class="submit-btn" @click="toSubmit('formInfo')">立即报名</a>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	const isEmail = (s) => {
		var regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
    return regex.test(s);
	}
	const isMobile = (s) => {
		return /^1[0-9]{10}$/.test(s)
	}
	const isValidPhoneNumber = (phoneNumber) =>{
		const regex = /^(\d{3,4}-)?\d{7,8}$/;
		return regex.test(phoneNumber);
	}


	export default {
		name: 'bannerTop',
		props: {
			comItem: {
				type: Object,
				value: {}
			},
			isLine2: {
				type: Boolean,
				value: false
			}
		},
		data() {
			var validatePhone= (rule, value, callback) => {
				if(!value){
					callback(new Error('请输入联系人电话'));
				}else if (!(isMobile(this.formInfo.phone)||isValidPhoneNumber(this.formInfo.phone))) {
				callback(new Error('手机号格式不正确'));
				} else {
				callback();
				}
			};
			var validateEmail= (rule, value, callback) => {
				if(!value){
					callback(new Error('请输入邮箱'));
				}else if (!isEmail(this.formInfo.email)) {
					callback(new Error('邮箱格式不正确'));
				} else {
					callback();
				}
			};
			return {
				applicationDialog: false,
				userId: '',
				day: '00',
				hour: '00',
				formInfo: {
					companyName: '', //单位名称
					userName: '',
					phone: '',
					email: ''
				},
				rules: {
					companyName: [
						{ required: true, message: '请输入单位名称', trigger: ['blur','change'] }
					],
					userName: [
						{ required: true, message: '请输入联系人姓名', trigger: ['blur','change'] }
					],
					phone: [
						{required: true, validator: validatePhone, trigger: ['blur','change'] }
					],
					email: [
						{ required: true,validator: validateEmail, trigger: ['blur','change'] }
					]
				}
			}
		},
		created(){
			this.userId = localStorage.getItem('userId')
			this.getCountDown()

		},
		methods: {
			//大赛结束时间倒计时
			getCountDown(){
				let nowtime = Date.parse(new Date())
				var count = (this.comItem.endTime - Date.parse(new Date()))
				console.log(nowtime)
				console.log(count)
				console.log(this.comItem.content)
				console.log(this.comItem.endTime)
				if (count <= 0) {
					return
				}
				let intervalId = setInterval(()=> {
					let time = (this.comItem.endTime - Date.parse(new Date()))
					if (time <= 0) {
						this.day = '00'
						this.hour = '00'
						clearInterval(intervalId)
						return
					}
					let day = Math.floor(time / 1000 / 3600 / 24)
					let hour = Math.floor(time / 1000 / 60 / 60 % 24);
					//let minute = Math.floor(t / 1000 / 60 % 60);
					//let second = Math.floor(t / 1000 % 60);
					if (hour < 10) {
						hour = "0" + hour
					}
					this.day = day
					this.hour = hour
				}, 1000)
			},
			//立即报名大赛
			async toSubmit(formName){
				this.$refs[formName].validate(async(valid) => {
				if (valid) {
					let param = {
					competitionId: this.comItem.id,
					userId: this.userId,
					mail: this.formInfo.email,
					companyName: this.formInfo.companyName,
					phone: this.formInfo.phone,
					userName: this.formInfo.userName
				}
				ajaxParam(param)
				const res = await post('v1/competition/enroll', qs.stringify(param))
				if(res.data.code==200){
					console.log('提交')
					this.$message.success('您的信息提交成功！')
					this.comItem.enrollFlag=1
					setTimeout(()=>{
						this.closeDialog()
					},300)

				} else {
					this.$message.error(res.data.msg)
				}
				} else {
					console.log('error submit!!');
					return false;
				}
				});
			},
			toEnter(){
				if(!this.userId){
					this.$router.push({
						path: '/login'
					})
					return
				}
				this.applicationDialog = true
			},
			closeDialog(){
				this.applicationDialog = false
			},
			toDetail(){
				this.$router.push({
					path: '/competitionIndex?id='+this.comItem.id
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.competition{
		// width: 1200px;
		min-height: 160px;
		margin: 20px auto 0;
		padding: 20px 0;
		background: #fff;
		border-radius: 12px;
		box-sizing: border-box;
		display: flex;
		justify-content: space-around;
		align-items: center;
		.competition-l{
			flex: 1;
			min-height: 120px;
			padding: 0 40px;
			border-right: 1px solid var(--color-border);
			.competition-name{
				display: flex;
				align-items: center;
				h3{
					margin-right: 10px;
					font-size: 18px;
					font-weight: bold;
				}
				span{
					display: block;
					width: 62px;
					height: 18px;
					background: rgba(207,23,29,.18);
					border-radius: 4px;
					color: #CF171D;
					font-size: 10px;
				}
			}
			.competition-info{
				margin: 13px 0;
				font-size: 12px;
				color: var(--color-text-opacity);
				line-height: 22px;
			}
			.line2{
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				overflow: hidden;
				-webkit-box-orient: vertical;	
			}
			.competition-tips{
				display: flex;
				justify-content: space-between;
				.organizer{
					font-size: 12px;
					color: var(--color-text-opacity);
				}
				.bonus{
					font-size: 18px;
					font-weight: bold;
					color: #CF171D;
				}
			}
		}
		.competition-m {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			width: 240px;
			height: 120px;
			border-right: 1px solid var(--color-border);
			ul {
				display: flex;
				margin-bottom: 8px;
				li{
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					width: 88px;
					height: 54px;
					margin-left: 2px;
					background: rgba(50,50,50,.06);
					border-radius: 2px;
					span:nth-of-type(1){
						padding-bottom: 2px;
						font-weight: bold;
					}
					span:nth-of-type(2){
						font-size: 12px;
					}
				}
			}
			.deadline{
				font-size: 12px;
				color: var(--color-text-opacity);
			}
		}
		.competition-r{
			display: flex;
			flex-direction: column;
			width: 200px;
			align-items: center;
			span{
				font-size: 12px;
				color: var(--color-text-opacity);
				line-height: 22px;
			}
		}
		.submit-btn{
			display: block;
			width: 88px;
			height: 34px;
			background: #CF171D;
			border-radius: 2px;
			margin-bottom: 12px;
			color: #fff;
			line-height: 34px;
			text-align: center;
		}
		.dialog-wrap .submit-btn{
			width: 200px;
			margin: 25px auto 0;
		}
		/deep/ .el-dialog__body{
			padding-top: 10px;
		}
	}
</style>
